import { create as createFedopsLogger } from '@wix/fedops-logger';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from 'components/App/App';
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://82f49e00013a9e77f909d6475ff2abf6@o37417.ingest.us.sentry.io/4510810932248576',
  sendDefaultPii: true,
});

createFedopsLogger('gg-stores-onboarding-app').appLoaded();

const domNode = document.getElementById('root')!;
const root = createRoot(domNode);

root.render(<App />);
